import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { getServiceDeskNavigationResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { forgeServicedeskQueueRoute } from '@jira/router-routes__forge-routes/src/forgeServicedeskQueueRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { forgeServiceDeskQueuePageEntrypoint } from './ui/servicedesk-queue/index.tsx';

export const forgeServicedeskQueueRouteEntry: Route = createEntry(
	forgeServicedeskQueueRoute,
	() => ({
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
		},

		resources: [...getServiceDeskNavigationResources(), getConsolidationStateResource()],
		entryPoint: () => forgeServiceDeskQueuePageEntrypoint,
		supportsPreviewPanel: true,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
